import App from '././App';
import { activateKeepAwake } from 'expo-keep-awake';
import { registerRootComponent } from 'expo';

if (__DEV__) {
	activateKeepAwake();
}

registerRootComponent(App);
